import { createFileRoute } from '@tanstack/react-router';
import { WorkspaceSettingsPage } from '@/features/workspace-settings/workspace-settings-page';

export const Route = createFileRoute('/_app/w/$workspaceId/settings/')({
    staticData: { crumbs: [{ label: 'shell.workspaceSettings' }] },
    component: function WorkspaceSettingsRoute() {
        const { organizationId, workspaceId } = Route.useRouteContext().workspaceScope;
        return <WorkspaceSettingsPage organizationId={organizationId} workspaceId={workspaceId} />;
    },
});
